// removed by extract-text-webpack-plugin
module.exports = {"table-wrapper":"styles__table-wrapper___3lrM8","table-column":"styles__table-column___2vY7U","column-header":"styles__column-header___1ULcK","shrink-small":"styles__shrink-small___HNu-7","row-header":"styles__row-header___3w68Z","fake-header":"styles__fake-header___31qTh","resizing-row-header":"styles__resizing-row-header___Nv3fw","degrees":"styles__degrees___2SqG2","dollar":"styles__dollar___2mUfy","table-title":"styles__table-title___1sBOA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LiveComponents/WeeklySummaryTable/styles.scss
// module id = 7598
// module chunks = 0